<template>
<div class="theme">
    <div class="item" v-for='(i,k) in showData' :key='k' @click="detail(i)">
        <div class="pic">
            <img :src="i.url" alt="">
        </div>
        <div class="text">
            <div class="title">{{i.name}}</div>
<!--            <div class="date">{{i.create_time}}</div>-->
            <!--<div class="cont">{{i.content}}</div>-->
        </div>
    </div>
  <div class="page">
    <i class="left iconfont icon-youjiantou" @click="prePage()"></i>
    <div class="itemPage" :class="{active: current===k}" v-for='(i,k) in new Array(Math.ceil(total / size))' :key='k'>
      <div @click="currentPage(k)">{{k+1}}</div>
    </div>
    <i class="right iconfont icon-youjiantou" @click="nextPage()"></i>
  </div>
</div>
</template>
<script>

import { formatTime } from '../../utils/index.js'

export default {
    filters: {
        formatTime
    },
    props: {
        data: Array
    },
  data() {
    return {
      showData: [],
      total: this.data.length,
      size: 5,
      current: 0
    }
  },
  created() {
    this.currentPage(0);
  },
  methods: {
    detail(data) {
      //   console.log(data)
      //   this.$$$api.activityDetail({id: data.id})
      this.$emit('detail', data)
    },
    nextPage() {
      if (this.current + 1 == Math.ceil(this.total / this.size)) {
      } else {
        this.current = this.current + 1;
      }
    },
    // 上一页
    prePage() {
      if (this.current == 0) {
      } else {
        this.current = this.current - 1;
      }
    },
    // 点击页码
    currentPage(i) {
      this.current = i;
      this.watch
    }
  },
  watch: {
    data: function (newData, oldData) {
      console.log("activity", newData)  //newData就是orderData
      this.total = newData.length;
      this.showData = newData.slice(this.current * this.size, (this.current + 1) * this.size);
      //	methods的函数在这里调用可以获取到newOrderData的值
      //this.order();
    },
    current: function (newData, oldData) {
      console.log("activity", newData)  //newData就是orderData
      this.showData = this.data.slice(newData * this.size, (newData + 1) * this.size);
      //	methods的函数在这里调用可以获取到newOrderData的值
      //this.order();
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~styl/mixin.styl"
.theme
    min-height 300px
    mt(20)
    fs(0)
    .item
        mb(30)
        pb(20)
        border-bottom 1px solid rgba(0,0,0,.1)
        .pic
            width 15%
            ib()
            va(middle)
            h(95)
            img
                wh()
        .text
            box()
            pl(20)
            ib()
            va(middle)
            width 85%
            .title
                fs(18)
                c(#333)
            .date
                fs(12)
                pt(20)
                pb(10)
                c(gray)
            .cont
                c(gray)
                fs(12)
theme = #f7aa05

.page
  ta(center)
  fs(0)

  .itemPage
    ib()
    w(40)
    h(30)
    ml(10)
    mr(10)
    va(middle)
    fs(17)
    lh(30)
    c(gray)
    _hover()

    &.active
      bg(theme)
      c(#fff)

  .left
    fs(15)
    c(gray)
    ib()
    transform rotate(180deg)
    vertical-align -4px
    mr(10)

    &:hover
      cursor pointer

  .right
    &:hover
      cursor pointer
    ml(10)
    va(middle)
    c(gray)
    fs(15)

</style>



// WEBPACK FOOTER //
// src/components/comment/theme.vue